import { create } from 'zustand'

export interface AuthUser {
  username: string
  email: string
  name: string
  is_superuser: boolean
}

interface AuthStore {
  user: AuthUser | null
  isAuthenticated: boolean
  loading: boolean
  setUser: (user: AuthUser) => void
  clearUser: () => void
  setLoading: (v: boolean) => void
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  isAuthenticated: false,
  loading: true,
  setUser: (user) => set({ user, isAuthenticated: true, loading: false }),
  clearUser: () => set({ user: null, isAuthenticated: false, loading: false }),
  setLoading: (loading) => set({ loading }),
}))
